import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Icon } from "../IconStyled";

export const GalleryIcon = ({ title, theme }) => (
  <Icon>
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        d="M8.26631 12.9366C7.81354 12.9296 7.37701 12.7668 7.03022 12.4757L4.74663 10.4644C4.38729 10.1287 3.8378 10.1021 3.4477 10.4016L0.200424 12.7899V14.3402C0.177086 14.7561 0.495362 15.1121 0.911242 15.1355C0.932655 15.1367 0.954149 15.1369 0.975602 15.1363H12.4773C12.9382 15.1363 13.3991 14.8011 13.3991 14.3402V10.2759L9.2719 12.6642C8.9685 12.8466 8.62031 12.9409 8.26631 12.9366Z"
        fill={theme.primaryColor}
      />
      <circle
        cx="8.09956"
        cy="7.95039"
        r="0.921825"
        fill={theme.primaryColor}
      />
      <path
        d="M15.5778 3.32035C15.4441 3.13814 15.2375 3.02337 15.0121 3.00609L3.5942 1.68623C3.3716 1.66758 3.14945 1.72681 2.96571 1.85385C2.80298 1.99516 2.69234 2.18696 2.65144 2.39857L2.46289 4.03269H12.4772C13.4319 4.05435 14.2039 4.81713 14.237 5.77156V13.167C14.237 13.1251 14.4256 13.0832 14.5094 12.9994C14.6828 12.8632 14.7834 12.6543 14.7817 12.4337L15.7663 3.92791C15.7881 3.7082 15.7201 3.48905 15.5778 3.32035Z"
        fill={theme.primaryColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.97635 4.87061H12.4781C12.9705 4.89102 13.3682 5.27963 13.3998 5.77146V9.2911L8.83267 11.9518C8.44049 12.1841 7.94413 12.1421 7.59662 11.847L5.2921 9.83582C4.63975 9.25408 3.6686 9.21033 2.96661 9.73108L0.201172 11.7423V5.77146C0.201172 5.31055 0.515438 4.87061 0.97635 4.87061ZM6.3396 7.95026C6.3396 8.92221 7.12753 9.7101 8.09944 9.7101C9.07139 9.7101 9.85928 8.92221 9.85928 7.95026C9.85928 6.97831 9.07135 6.19043 8.09944 6.19043C7.12749 6.19043 6.3396 6.97835 6.3396 7.95026Z"
        fill={theme.primaryColor}
      />
    </svg>
  </Icon>
);

GalleryIcon.propTypes = {
  title: PropTypes.string,
  theme: PropTypes.shape({}).isRequired
};

GalleryIcon.defaultProps = {
  title: "Gallery Icon"
};

export default withTheme(GalleryIcon);
